export const useProductStore = defineStore('product', () => {
  const runtimeConfig = useRuntimeConfig()

  const { data: products, error, pending, refresh } = useFetch('products', {
    method: 'GET',
    baseURL: runtimeConfig.public.apiUrl + '/esim/v1/',
    transform: (res: {
      success: boolean,
      data: Partial<IProduct>[]
    }) => {
      if (!res?.success) {
        throw new Error('Failed to fetch products')
      }
      return res.data
    }
  })

  return {
    products,
    error,
    pending,
    refresh
  }
})
